/**
 * 手当マスタ
 * 手本: src/domain/master/labor/executive.ts
 */
export interface Allowance {
  allowanceId: string,
  allowanceCode: string,
  allowanceName: string,
  /** 申請時表示メッセージ（申請画面の「申請内容」列） */
  dispMessage: string,
  /** 申請時表示単位（円・回など。表示専用で計算上の意味は持たない） */
  dispUnit: string,
  deleted: boolean,
  createUser: string,
  updateUser: string,
}

export default class AttendAllowanceDomain {
  constructor(private rawData: Allowance) {
    // do nothing
  }

  static generateInitial(): AttendAllowanceDomain {
    return new AttendAllowanceDomain({
      allowanceId: '',
      allowanceCode: '',
      allowanceName: '',
      dispMessage: '',
      dispUnit: '',
      deleted: false,
      createUser: '',
      updateUser: '',
    });
  }

  getRawData(): Allowance {
    return this.rawData;
  }

  get allowanceId(): string {
    return this.rawData.allowanceId;
  }

  set allowanceId(allowanceId: string) {
    this.rawData.allowanceId = allowanceId;
  }

  get allowanceCode(): string {
    return this.rawData.allowanceCode;
  }

  set allowanceCode(allowanceCode: string) {
    this.rawData.allowanceCode = allowanceCode;
  }

  get allowanceName(): string {
    return this.rawData.allowanceName;
  }

  set allowanceName(allowanceName: string) {
    this.rawData.allowanceName = allowanceName;
  }

  get dispMessage(): string {
    return this.rawData.dispMessage;
  }

  set dispMessage(dispMessage: string) {
    this.rawData.dispMessage = dispMessage;
  }

  get dispUnit(): string {
    return this.rawData.dispUnit;
  }

  set dispUnit(dispUnit: string) {
    this.rawData.dispUnit = dispUnit;
  }
}
